import { ElementRef, HostListener, Directive, OnInit } from '@angular/core';

@Directive({
  selector: 'textarea[autosize]'
})

export class Autosize implements OnInit {
  @HostListener('input', ['$event.target'])
  onInput(textArea:HTMLTextAreaElement):void {
    this.adjust();
  }
  constructor(public element:ElementRef) {}

  ngOnInit():void {
    setTimeout(() => this.adjust(), 0);
  }

  adjust():void {
    const textArea = this.element.nativeElement;
    textArea.style.overflow = 'hidden';
    textArea.style.height = '40px';
    textArea.style.height = textArea.scrollHeight + 'px';
  }
}


// WEBPACK FOOTER //
// ./src/directives/autosize/autosize.ts